import AltSkuField from '@/catalog/components/AltSkuField/AltSkuField';
import { FieldType } from '@/catalog/constants/fieldTypes';
import { returnFieldValue } from '@/catalog/helpers/returnFieldValue';
import { Field } from '@/catalog/types/field';
import { ALL_CONTEXTS } from '@/common/constants/context';

export const FIELD_ALT_SKU: Field = {
  label: 'Alt. SKU',
  fullLabel: 'Alternative SKU',
  key: 'altSku',
  type: FieldType.Custom,
  getValue(p) {
    return p.altSku;
  },
  getText: returnFieldValue,
  render(p) {
    return <AltSkuField value={this.getValue(p)} />;
  },
  contexts: ALL_CONTEXTS,
};
